// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.been-since {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-family: 'Rubik', 'sans-serif';
}

.been-since p {
    margin: 0.1em;
}

.been-since p.been-since-formatted-value {
    font-size: 2.4rem;
    color: var(--secondary-color);
    margin-top: 0.3em;
}

.been-since p.been-since-formatted-value.alert {
    color: var(--soft-red-color);
}

.a-long-time {
    color: var(--header-color);
}

.running-timer {
    font-family: 'RobotoMono', monospace;
}

.been-since p.since-last {
    color: var(--light-grey-color);
    margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/BeenSince.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB","sourcesContent":[".been-since {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    font-family: 'Rubik', 'sans-serif';\n}\n\n.been-since p {\n    margin: 0.1em;\n}\n\n.been-since p.been-since-formatted-value {\n    font-size: 2.4rem;\n    color: var(--secondary-color);\n    margin-top: 0.3em;\n}\n\n.been-since p.been-since-formatted-value.alert {\n    color: var(--soft-red-color);\n}\n\n.a-long-time {\n    color: var(--header-color);\n}\n\n.running-timer {\n    font-family: 'RobotoMono', monospace;\n}\n\n.been-since p.since-last {\n    color: var(--light-grey-color);\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
